module.exports = __webpack_public_path__ + "img/clapperboard.3a5318d5.svg";